export function toGroups<T>(
  maxGroupSize: number,
  array: ReadonlyArray<T>,
): ReadonlyArray<ReadonlyArray<T>> {
  const groupCount = Math.ceil(array.length / maxGroupSize)
  const groupSize = Math.ceil(array.length / groupCount)
  let currentGroup: T[] = []
  const groups = [currentGroup]

  for (const element of array) {
    if (currentGroup.length < groupSize) {
      currentGroup.push(element)
    } else {
      currentGroup = [element]
      groups.push(currentGroup)
    }
  }

  return groups
}

export const deduplicate = <T>(array: T[]): T[] => [...new Set(array)]
